/* unplugin-vue-components disabled */import script from "./HomeCapabilities.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCapabilities.vue?vue&type=script&setup=true&lang=js"

import "./HomeCapabilities.vue?vue&type=style&index=0&id=44787cae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44787cae"]])

export default __exports__